import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import {
    IFilterParams,
    IRateImportItem,
    IRateImportItemError,
    IRateImportItemRAW,
    IRateListItem,
    ISelectList,
} from '../../interfaces';

export function useRatesSelect(): ISelectList {
    return useContext(MobXProviderContext).RootStore.ratesStore.select;
}
export function useRatesList(): IRateListItem[] {
    return useContext(MobXProviderContext).RootStore.ratesStore.list;
}

export function useRatesImportList(): IRateImportItem[] {
    const { importErrorList, importList } = useContext(MobXProviderContext).RootStore.ratesStore;
    return importList.map((listItem: IRateImportItemRAW) => {
        const errorItem = importErrorList.find((e: IRateImportItemError) => e.id === listItem.id);
        return { ...listItem, ...(errorItem ? errorItem : {}) };
    });
}

export function useRatesFilterParams(): IFilterParams {
    return useContext(MobXProviderContext).RootStore.ratesStore.filterParams;
}
